import { useEffect, useState } from 'react'
import { api } from '../lib/api'
import type { Tweet } from '../types'
import TweetCard from './TweetCard'

function AlertHistory() {
  const [alerts, setAlerts] = useState<Tweet[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    loadAlerts()
  }, [])

  const loadAlerts = async () => {
    setIsLoading(true)
    const response = await api.get<{ items: Tweet[] }>('/api/tweets', {
      only_alerts: true,
      limit: 100,
    })

    if (response.success && response.data) {
      setAlerts(response.data.items)
    }
    setIsLoading(false)
  }

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
          Alert History
        </h2>
        <button
          onClick={loadAlerts}
          disabled={isLoading}
          className="btn-secondary text-sm"
        >
          {isLoading ? 'Loading...' : 'Refresh'}
        </button>
      </div>

      {isLoading && alerts.length === 0 ? (
        <div className="card p-8 text-center">
          <svg
            className="w-8 h-8 mx-auto animate-spin text-primary-600"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
        </div>
      ) : alerts.length === 0 ? (
        <div className="card p-8 text-center text-gray-500 dark:text-gray-400">
          <svg
            className="w-12 h-12 mx-auto mb-4 text-gray-300 dark:text-gray-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
          No alerts yet. Alerts will appear here when keywords match.
        </div>
      ) : (
        <div className="space-y-4">
          {alerts.map((tweet) => (
            <TweetCard key={tweet.tweet_id} tweet={tweet} />
          ))}
        </div>
      )}
    </div>
  )
}

export default AlertHistory
